import type { Traducao } from '../tipos';

/** Revisões, perfil do usuário e página de rota inexistente. */
export const revisoes: Traducao = {
  pt: {
    revisoes: {
      // Rótulo do badge de status do ciclo. O valor cru (aberta, em_andamento…)
      // continua indo para a API; só o texto na tela sai daqui.
      status: {
        aberta: 'Aberta',
        em_andamento: 'Em andamento',
        concluida: 'Concluída',
        cancelada: 'Cancelada',
      },
      statusItem: {
        pendente: 'Pendente',
        em_andamento: 'Fazendo',
        feito: 'Feito',
        nao_aplicavel: 'Não aplicável',
      },
      // Subtipo da anotação do PDF, como o Acrobat a nomeia.
      tipoAnotacao: {
        Text: 'Balão',
        Highlight: 'Destaque',
        StrikeOut: 'Tachado',
        Underline: 'Sublinhado',
        Squiggly: 'Ondulado',
        FreeText: 'Caixa de texto',
        Square: 'Retângulo',
        Circle: 'Elipse',
        Manual: 'Digitado',
      },
      lista: {
        titulo: 'Revisões',
        semProjeto: 'Selecione um projeto para ver as revisões.',
        resumoUm: '{{total}} ciclo de revisão neste projeto',
        resumoMuitos: '{{total}} ciclos de revisão neste projeto',
        erroCarregar: 'Não foi possível carregar as revisões.',
        acao: {
          registrarRetorno: 'Registrar retorno do cliente',
        },
        kpi: {
          ciclosAbertos: 'Ciclos em aberto',
          comentariosPendentes: 'Comentários a tratar',
          comentariosResolvidos: 'Já tratados nos ciclos abertos',
          ciclosConcluidos: 'Ciclos concluídos',
        },
        filtro: {
          statusAria: 'Filtrar por status',
          statusTodos: 'Status: todos',
          grdAria: 'Filtrar por GRD de origem',
          grdTodas: 'GRD de origem: todas',
        },
        tabela: {
          apreciacao: 'Apreciação',
          grdOrigem: 'GRD de origem',
          revDoc: 'Rev. doc.',
          recebidaEm: 'Recebida em',
          checklist: 'Checklist',
          rodadaTitulo: '{{rodada}}º retorno do cliente',
        },
        vazio: {
          titulo: 'Nenhuma revisão registrada',
          descricao: 'Quando o cliente devolver a apreciação comentada, registre o retorno para abrir o checklist.',
        },
      },
      modalRetorno: {
        titulo: 'Registrar retorno do cliente',
        arquivoRotulo: 'PDF devolvido pelo cliente',
        arquivoEscolher: 'Escolher o PDF com os comentários',
        arquivoDica: 'Comentários do Acrobat/Foxit são lidos automaticamente',
        lendoPdf: 'Lendo os comentários do PDF…',
        resumoUm: '{{comentarios}} comentário em {{paginas}} páginas',
        resumoMuitos: '{{comentarios}} comentários em {{paginas}} páginas',
        documentoIdentificado: 'Documento identificado como',
        semParteIdentificada: 'Sem parte identificada',
        porParteUm: '• {{parte}}: {{qtd}} comentário',
        porParteMuitos: '• {{parte}}: {{qtd}} comentários',
        primeiroComentario: 'Primeiro: “{{texto}}” ({{tipo}}, p. {{pagina}})',
        apreciacaoRotulo: 'Apreciação *',
        apreciacaoPlaceholder: 'Selecione a apreciação…',
        apreciacaoDica: 'Preenchida sozinha quando o número do documento aparece na capa do PDF. Confira antes de confirmar.',
        grdRotulo: 'GRD em que o documento saiu',
        grdVazia: 'Sem GRD vinculada',
        observacoesPlaceholder: 'Ex.: retorno recebido por e-mail em 20/08, prazo de resposta até 05/09.',
        aviso: 'Ao confirmar, a apreciação volta para <b class="font-semibold">Em revisão</b> e os comentários entram como checklist na aba Partes.',
        acaoAbrir: 'Abrir revisão',
        erroSemComentarios: 'Nenhum comentário nativo foi encontrado neste PDF. Se as marcações foram achatadas ao salvar, peça ao cliente o arquivo com os comentários ativos.',
        erroLerPdf: 'Não foi possível ler o PDF.',
        erroApreciacaoObrigatoria: 'Escolha a apreciação a que este documento pertence.',
        erroRegistrar: 'Não foi possível registrar o retorno.',
      },
      detalhe: {
        titulo: '{{numero}} — revisão {{revisao}}',
        devolvidoNa: 'devolvido na {{guia}}',
        recebidoEm: 'recebido em {{data}}',
        pdfComentado: 'PDF comentado',
        editarApreciacao: 'Editar apreciação',
        cancelarRevisao: 'Cancelar revisão',
        concluirRevisao: 'Concluir revisão',
        progresso: '{{tratados}} de {{total}} comentários tratados',
        resumoContagem: '{{feitos}} feitos · {{naoAplicaveis}} não aplicáveis · {{pendentes}} a tratar',
        concluidaEm: 'Concluída em {{data}}',
        retramitadaNa: 'retramitada na {{guia}}',
        apreciacaoTramitada: 'a apreciação ficou como Tramitado após revisão.',
        naoEncontrada: 'Revisão não encontrada.',
        erroCarregar: 'Não foi possível carregar a revisão.',
        erroSalvar: 'Não foi possível salvar.',
        erroSalvarAlteracao: 'Não foi possível salvar a alteração.',
        erroSalvarDescricao: 'Não foi possível salvar a descrição.',
        erroAdicionar: 'Não foi possível adicionar o item.',
        erroRemover: 'Não foi possível remover.',
        erroCancelar: 'Não foi possível cancelar.',
        confirmarRemover: 'Remover este item do checklist?',
        promptCancelar: 'Por que esta revisão está sendo cancelada?',
        capa: {
          rotulo: 'Na capa:',
          linha: 'linha',
          numero: 'Nº {{numero}}',
          numeroEmitente: 'Nº Emitente',
          colunaArcelor: 'coluna Nº ArcelorMittal em branco',
          descricao: 'DESCRIÇÃO',
        },
        item: {
          cabecalho: '#{{indice}} · p. {{pagina}} · {{tipo}}',
          parteAria: 'Parte da máquina',
          parteAutoTitulo: 'Parte deduzida da página em que o comentário está',
          semParteDefinida: 'Sem parte definida',
          parteDoPdf: '{{parte}} (do PDF)',
          acaoFeito: 'Feito',
          acaoNaoSeAplica: 'Não se aplica',
          resolucaoPlaceholder: 'O que foi feito (ou por que não se aplica)…',
        },
        adicionar: {
          titulo: 'Adicionar item que não veio no PDF',
          placeholder: 'Ex.: cliente pediu por telefone para refazer a foto da guarda superior.',
          semParte: 'Sem parte',
        },
      },
      modalConcluir: {
        titulo: 'Concluir revisão',
        pendentesUm: 'Ainda há {{pendentes}} comentário sem tratamento.',
        pendentesMuitos: 'Ainda há {{pendentes}} comentários sem tratamento.',
        forcar: 'Concluir mesmo assim (justifique abaixo)',
        grdRotulo: 'GRD em que o documento revisado foi retramitado',
        grdVazia: 'Ainda não retramitado',
        aviso: 'A apreciação passa a <b class="font-semibold">Tramitado após revisão</b> e o checklist sai da aba Partes.',
        acaoConcluir: 'Concluir',
        erroConcluir: 'Não foi possível concluir.',
      },
    },
    perfil: {
      titulo: 'Meu perfil',
      semLogin: 'Faça login para acessar seu perfil.',
      fotoRotulo: 'Foto',
      fotoAlt: 'Foto do perfil',
      fotoDica: 'Adicione uma foto para seu perfil (aparece onde você é citado)',
      creaRotulo: 'Registro Profissional / CREA',
      creaPlaceholder: 'Ex.: CREA/SP 123456',
      cargoRotulo: 'Função / Cargo',
      cargoPlaceholder: 'Ex.: Engenheiro de Segurança, Técnico NR-12',
      descricaoRotulo: 'Descrição detalhada',
      descricaoPlaceholder: 'Ex.: Responsável por vistorias\nElaboração de laudos e apreciações...',
      descricaoDica: 'Descreva as atribuições ou múltiplas funções. A quebra de linha com a tecla Enter será mantida.',
      assinaturaRotulo: 'Assinatura padrão',
      assinaturaDica: 'Usada como padrão em documentos e apreciações',
      acaoSalvar: 'Salvar perfil',
      erroSalvar: 'Erro ao salvar perfil',
    },
    naoEncontrada: {
      titulo: 'Página não encontrada',
      descricao: 'Desculpe, a página que você está procurando não existe ou foi movida.',
      voltarDashboard: 'Voltar ao Dashboard',
      ajuda: {
        titulo: 'Precisa de ajuda?',
        endereco: '• Verifique se o endereço está correto',
        administrador: '• Entre em contato com o administrador do sistema',
        menu: '• Use o menu lateral para navegar',
      },
    },
  },
  en: {
    revisoes: {
      status: {
        aberta: 'Open',
        em_andamento: 'In progress',
        concluida: 'Completed',
        cancelada: 'Cancelled',
      },
      statusItem: {
        pendente: 'Pending',
        em_andamento: 'Doing',
        feito: 'Done',
        nao_aplicavel: 'Not applicable',
      },
      tipoAnotacao: {
        Text: 'Sticky note',
        Highlight: 'Highlight',
        StrikeOut: 'Strikethrough',
        Underline: 'Underline',
        Squiggly: 'Squiggly',
        FreeText: 'Text box',
        Square: 'Rectangle',
        Circle: 'Ellipse',
        Manual: 'Typed',
      },
      lista: {
        titulo: 'Reviews',
        semProjeto: 'Select a project to see the reviews.',
        resumoUm: '{{total}} review cycle in this project',
        resumoMuitos: '{{total}} review cycles in this project',
        erroCarregar: 'Could not load the reviews.',
        acao: {
          registrarRetorno: 'Record client return',
        },
        kpi: {
          ciclosAbertos: 'Open cycles',
          comentariosPendentes: 'Comments to handle',
          comentariosResolvidos: 'Already handled in open cycles',
          ciclosConcluidos: 'Completed cycles',
        },
        filtro: {
          statusAria: 'Filter by status',
          statusTodos: 'Status: all',
          grdAria: 'Filter by source GRD',
          grdTodas: 'Source GRD: all',
        },
        tabela: {
          apreciacao: 'Assessment',
          grdOrigem: 'Source GRD',
          revDoc: 'Doc. rev.',
          recebidaEm: 'Received on',
          checklist: 'Checklist',
          rodadaTitulo: 'Client return #{{rodada}}',
        },
        vazio: {
          titulo: 'No review recorded',
          descricao: 'When the client returns the commented assessment, record the return to open the checklist.',
        },
      },
      modalRetorno: {
        titulo: 'Record client return',
        arquivoRotulo: 'PDF returned by the client',
        arquivoEscolher: 'Choose the PDF with the comments',
        arquivoDica: 'Acrobat/Foxit comments are read automatically',
        lendoPdf: 'Reading the comments in the PDF…',
        resumoUm: '{{comentarios}} comment in {{paginas}} pages',
        resumoMuitos: '{{comentarios}} comments in {{paginas}} pages',
        documentoIdentificado: 'Document identified as',
        semParteIdentificada: 'No machine part identified',
        porParteUm: '• {{parte}}: {{qtd}} comment',
        porParteMuitos: '• {{parte}}: {{qtd}} comments',
        primeiroComentario: 'First: “{{texto}}” ({{tipo}}, p. {{pagina}})',
        apreciacaoRotulo: 'Assessment *',
        apreciacaoPlaceholder: 'Select the assessment…',
        apreciacaoDica: 'Filled in on its own when the document number shows on the PDF cover. Check it before confirming.',
        grdRotulo: 'GRD the document went out in',
        grdVazia: 'No GRD linked',
        observacoesPlaceholder: 'E.g.: return received by e-mail on 20/08, reply due by 05/09.',
        aviso: 'On confirming, the assessment goes back to <b class="font-semibold">Under review</b> and the comments become a checklist on the Parts tab.',
        acaoAbrir: 'Open review',
        erroSemComentarios: 'No native comment was found in this PDF. If the markups were flattened on saving, ask the client for the file with the comments still active.',
        erroLerPdf: 'Could not read the PDF.',
        erroApreciacaoObrigatoria: 'Choose the assessment this document belongs to.',
        erroRegistrar: 'Could not record the return.',
      },
      detalhe: {
        titulo: '{{numero}} — review {{revisao}}',
        devolvidoNa: 'returned in {{guia}}',
        recebidoEm: 'received on {{data}}',
        pdfComentado: 'Commented PDF',
        editarApreciacao: 'Edit assessment',
        cancelarRevisao: 'Cancel review',
        concluirRevisao: 'Complete review',
        progresso: '{{tratados}} of {{total}} comments handled',
        resumoContagem: '{{feitos}} done · {{naoAplicaveis}} not applicable · {{pendentes}} to handle',
        concluidaEm: 'Completed on {{data}}',
        retramitadaNa: 'resubmitted in {{guia}}',
        apreciacaoTramitada: 'the assessment ended up as Submitted after review.',
        naoEncontrada: 'Review not found.',
        erroCarregar: 'Could not load the review.',
        erroSalvar: 'Could not save.',
        erroSalvarAlteracao: 'Could not save the change.',
        erroSalvarDescricao: 'Could not save the description.',
        erroAdicionar: 'Could not add the item.',
        erroRemover: 'Could not remove.',
        erroCancelar: 'Could not cancel.',
        confirmarRemover: 'Remove this item from the checklist?',
        promptCancelar: 'Why is this review being cancelled?',
        capa: {
          rotulo: 'On the cover:',
          linha: 'row',
          numero: 'No. {{numero}}',
          numeroEmitente: 'Issuer No.',
          colunaArcelor: 'ArcelorMittal No. column left blank',
          descricao: 'DESCRIPTION',
        },
        item: {
          cabecalho: '#{{indice}} · p. {{pagina}} · {{tipo}}',
          parteAria: 'Machine part',
          parteAutoTitulo: 'Machine part inferred from the page the comment sits on',
          semParteDefinida: 'No machine part set',
          parteDoPdf: '{{parte}} (from the PDF)',
          acaoFeito: 'Done',
          acaoNaoSeAplica: 'Not applicable',
          resolucaoPlaceholder: 'What was done (or why it does not apply)…',
        },
        adicionar: {
          titulo: 'Add an item that did not come in the PDF',
          placeholder: 'E.g.: the client asked by phone to retake the photo of the upper guard.',
          semParte: 'No machine part',
        },
      },
      modalConcluir: {
        titulo: 'Complete review',
        pendentesUm: 'There is still {{pendentes}} comment left to handle.',
        pendentesMuitos: 'There are still {{pendentes}} comments left to handle.',
        forcar: 'Complete anyway (justify below)',
        grdRotulo: 'GRD the revised document was resubmitted in',
        grdVazia: 'Not resubmitted yet',
        aviso: 'The assessment moves to <b class="font-semibold">Submitted after review</b> and the checklist leaves the Parts tab.',
        acaoConcluir: 'Complete',
        erroConcluir: 'Could not complete.',
      },
    },
    perfil: {
      titulo: 'My profile',
      semLogin: 'Sign in to access your profile.',
      fotoRotulo: 'Photo',
      fotoAlt: 'Profile photo',
      fotoDica: 'Add a photo to your profile (it shows wherever you are credited)',
      creaRotulo: 'Professional Registration / CREA',
      creaPlaceholder: 'E.g.: CREA/SP 123456',
      cargoRotulo: 'Role / Job title',
      cargoPlaceholder: 'E.g.: Safety Engineer, NR-12 Technician',
      descricaoRotulo: 'Detailed description',
      descricaoPlaceholder: 'E.g.: Responsible for inspections\nWriting reports and risk assessments...',
      descricaoDica: 'Describe the duties or the several roles. Line breaks made with the Enter key are kept.',
      assinaturaRotulo: 'Default signature',
      assinaturaDica: 'Used as the default in documents and risk assessments',
      acaoSalvar: 'Save profile',
      erroSalvar: 'Error saving profile',
    },
    naoEncontrada: {
      titulo: 'Page not found',
      descricao: 'Sorry, the page you are looking for does not exist or has been moved.',
      voltarDashboard: 'Back to Dashboard',
      ajuda: {
        titulo: 'Need help?',
        endereco: '• Check that the address is correct',
        administrador: '• Contact the system administrator',
        menu: '• Use the side menu to navigate',
      },
    },
  },
};
